export const ZERO_OFFER_ID = "ZeroOffer";
